<form [formGroup]="form">
  <div class="modal-header">
    <h5 class="modal-title">
      <i class="fal fa-calendar-alt"></i> <ng-container i18n>Upload Airbnb transactions from CSV Files</ng-container>
    </h5>
    <button (click)="onClose()" type="button" class="close">
      <i class="far fa-times"></i>
    </button>
  </div>
  <div class="modal-body">
    <app-csv-file-parser
      [columnDefs]="columnDefs"
      [guide]="guide"
      (parsed)="onCsvFilesParsed($event)"
    ></app-csv-file-parser>
    <div class="row">
      <div class="col-sm-12">
        <app-rental-select
          i18n-placeholder
          [ctrl]="form.get('rental')"
          [bindValue]="selectRental"
          [multiple]="false"
          placeholder="Rental"
        ></app-rental-select>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button (click)="onClose()" type="button" class="btn btn-light">
      <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
    </button>
    <button
      (click)="onCreate()"
      [disabled]="!files?.length || form.invalid || hasErrors()"
      type="button"
      class="btn btn-secondary-info create-btn"
    >
      <i class="cs-icon cs-icon-upload"></i> <ng-container i18n>upload</ng-container>
    </button>
  </div>
</form>
